/*
 * Portions of this code are from Novel (https://github.com/steven-tey/novel)
 * Copyright (c) 2023 Steven Tey
 * Licensed under the Apache License, Version 2.0
 */

import { createStore } from 'jotai'

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const novelStore: any = createStore()
export * from 'jotai'
